import { Injectable } from '@angular/core';
import { IndicatorWidgetConfig } from '../../../interfaces';
import { CustomWidgetService } from '../../classes/custom-widget-service';

@Injectable({
	providedIn: 'root',
})
export class IndicatorWidgetConfigService extends CustomWidgetService<IndicatorWidgetConfig> {
	protected override addWidgetsToBoard(boardId: string, widgets: IndicatorWidgetConfig[]): void {
		const boards = this.appSettingsService.webAppSettings.boards || [];
		const board = boards.find((b) => b.id === boardId);

		if (board?.indicatorWidgets) {
			board.indicatorWidgets = widgets;
		}
	}

	protected override getWidgetsById(id: string): IndicatorWidgetConfig[] {
		const boards = this.appSettingsService.webAppSettings.boards || [];
		const board = boards.find((b) => b.id === id);

		if (!board?.indicatorWidgets) {
			return [];
		}

		return board.indicatorWidgets;
	}

	protected override validateWidget(widget: IndicatorWidgetConfig): boolean {
		return !(
			!widget.id ||
			!widget.headline ||
			!widget.value ||
			!widget.vehicles ||
			widget.vehicles.length === 0
		);
	}

	protected override getTranslationKey(): string {
		return 'indicator_widget';
	}
}
